
import * as types from '../actions/types';

const INITIAL_STATE = {
    email: '',
    firstName: '',
    lastName: '',
    providerType: '',
    providerKey: '',
    providerToken: '',
    phoneNumber: '',
    deviceId: '',
    deviceToken: '',
    deviceType: '',
    verificationCode: '',
    verificationToken: ''
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case types.SET_SOCIAL_SIGNUP:
            return { ...state, ...action.payload };

        case types.CLEAR_SOCIAL_SIGNUP:
            return INITIAL_STATE;

        default:
            return state;

    }
}